// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"c7efab6b","73":"cd68ef61","74":"1d05ff6b","87":"c549f64d","181":"42a1f7a9","268":"a5dfe87a","352":"526c7772","358":"2f4da8ae","361":"3aedcb7f","684":"d7d416ae","890":"d5a80a15"}[chunkId] + ".chunk.js";
};